var ProductStatus;
(function(ProductStatus1) {
    ProductStatus1["AVAILABLE"] = 'Available';
    ProductStatus1["NOT_FOR_SALE"] = 'Not-for-sale';
    ProductStatus1["OUT_OF_STOCK"] = 'Out-of-stock';
    ProductStatus1["AVAILABLE_ONE_LEFT"] = 'Available-oneleft';
    ProductStatus1["AVAILABLE_TWO_LEFT"] = 'Available-twoleft';
    ProductStatus1["AVAILABLE_FEW_LEFT"] = 'Available-fewleft';
})(ProductStatus || (ProductStatus = {}));
var ProductCategory;
(function(ProductCategory1) {
    ProductCategory1["OPTICS"] = "OPTICS";
    ProductCategory1["SUN"] = "SUN";
    ProductCategory1['CONTACT_LENSES'] = 'CONTACT LENSES';
    ProductCategory1['EYEWEAR'] = 'EYEWEAR';
    ProductCategory1["ACCESSORIES"] = "ACCESSORIES";
})(ProductCategory || (ProductCategory = {}));

export { ProductCategory, ProductStatus };
//# sourceMappingURL=products.js.map
